export function convertCamelCaseToTitleCase(inputString) {
  return inputString
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Add a space between lowercase and uppercase letters
    .replace(/(^|\s)([a-z])/g, (match, group1, group2) => group1 + group2.toUpperCase()); // Capitalize the first letter of each word
}
